import { Injectable } from '@angular/core';
import { CategoryWithReplyTemplate } from '@sb-tools/typescript/models/category-with-reply-template.model';
import { ReplyTemplate } from '@sb-tools/typescript/models/reply-template.model';
import { ReplyTemplatesTree } from '@sb-tools/typescript/models/reply-templates-tree.model';
import { TemplateEntity } from './template-entity.model';
import { TemplateEntityType } from './template-entity-type.enum';

@Injectable({
    providedIn: 'root',
})
export class ReplyTemplateService {
    allReplyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    isReplyTemplatesLoaded: boolean;
    personalReplyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    personalReplyTemplatesTree: ReplyTemplatesTree;
    replyTemplates: (CategoryWithReplyTemplate | ReplyTemplate)[] = [];
    replyTemplatesTree: ReplyTemplatesTree;

    getTemplateCategoryById(templatesList: TemplateEntity[], id: number): TemplateEntity {
        let replyTemplate;

        for (const template of templatesList) {
            if (template.id === id && template.type === TemplateEntityType.category) {
                return template;
            }

            if (template.children?.length > 0) {
                replyTemplate = this.getTemplateCategoryById(template.children, id);

                if (replyTemplate) {
                    return replyTemplate;
                }
            }
        }

        return null;
    }
}
